import { Number } from 'core-js'
import store from '../../store/index.js'
/**
 * item = {
 *  id: Number, // unique id
 *  group: String, // micom, circuit
 *  type: Sting, // part, board, tool, sensor
 *  idname: String, // identified name of electronics
 *  thumbnail: String, // file name of thumbnail in componenet list
 *  name: { // version name of electronics
 *      kor: String, // korean version
 *      en: String // english version
 *  },
 *  code: { // used to create simulation json
 *      type: String, // E(ctronics)
 *      name: String  // shortened component name (Resistor -> RE, Breadboard -> BB)
 *  },
 *  info: {
 *      model: String, // model of the electronic
 *      img: String, // real electronics image file name
 *      description: String // description for the electronic
 *  },
 *  data: { // attributes of this electronic(elct)
 *      limit: Number, // limit to use of electronics in simulation canvas
 *      signal: String, // for socket
 *      resist: Number, // all electronics have resist (ohm)
 *  }
 * }
 *
 *       {
          id: 1,
          group: '',
          type: '',
          idname: '',
          thumbnail: '',
          name: {
            kor: '',
            en: ''
          },
          info: {
            model: '',
            img: '',
            description: ''
          },
          data: {
            limit: 1,
            signal: '',
            resist: 0
          }
      },
 */
export const components = {
  items: [
    {
      id: 1,
      group: 'micom',
      type: 'part',
      idname: 'Resistor',
      thumbnail: 'resistor.svg',
      name: {
        kor: '저항',
        en: 'resistor'
      },
      info: {
        model: '4색 저항',
        img: 'resistor.png',
        description: '저항은 전기를 열로 바꿔주는 전자부품입니다. 저항에는 여러 색의 띠가 표현되어 있는데, 이 띠의 색으로 저항 값을 구분합니다. 전류가 너무 과하면 전자부품이 파손될 수 있기 때문에 저항은 과전류로부터 전자부품을 보호하기 위해 사용됩니다.'
      },
      code: {
        type: 'E',
        name: 'RE'
      },
      data: {
        limit: 10,
        signal: ''
      },
      attr: {
        resist: 330
      }
    },
    {
      id: 2,
      group: 'micom',
      type: 'part',
      idname: 'Breadboard',
      thumbnail: 'breadboard.svg',
      name: {
        kor: '브레드보드',
        en: 'breadboard'
      },
      info: {
        model: '-',
        img: 'breadboard.png',
        description: '브레드보드(일명 빵판)는 전자 회로를 쉽게 구성할 수 있는 기본 판입니다. 일반적으로 전자 회로를 구성할 때엔 납땜해야 하지만, 브레드 보드는 소자를 꼽는 것으로 회로를 구성할 수 있습니다. 보드의 위쪽과 아래쪽에 붉은색 선과 파란색 선으로 표시되어 있습니다. 파란색 선은 - 로 GND 케이블과 연결할 때 사용되고, 빨간색 선은 + 로 5v 전원 케이블을 연결할 때 사용됩니다. 녹색 영역은 각종 전자 소자들을 꽂을 때 사용됩니다.'
      },
      code: {
        type: 'E',
        name: 'BB'
      },
      data: {
        limit: 2,
        signal: ''
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 3,
      group: 'micom',
      type: 'board',
      idname: 'Arduino',
      thumbnail: 'arduino.svg',
      name: {
        kor: '아두이노R3 우노',
        en: 'Arduino R3 UNO'
      },
      info: {
        model: 'R3 UNO',
        img: 'arduino.png',
        description: '아두이노는 오픈 소스를 기반으로 한 단일 보드 마이크로컨트롤러로 완성된 보드와 관련 개발 도구 및 환경을 말합니다. 2005년 이탈리아의 IDII에서 하드웨어에 익숙지 않은 학생들이 자신들의 디자인 작품을 손쉽게 제어할 수 있게 하려고 고안되었습니다. 아두이노는 다수의 스위치나 센서로부터 값을 받아들여, LED나 모터와 같은 외부 전자 장치들을 통제함으로써 환경과 상호작용이 가능한 물건을 만들어 낼 수 있습니다.'
      },
      code: {
        type: 'E',
        name: 'AD'
      },
      data: {
        limit: 1,
        signal: 'input'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 4,
      group: 'micom',
      type: 'part',
      idname: 'Led',
      thumbnail: 'led-red.svg',
      name: {
        kor: '빨간색 LED',
        en: 'LED'
      },
      info: {
        model: '-',
        img: 'led-red.png',
        description: 'LED는 전압을 가했을 때 발광하는 반도체 소자로, 짧은 핀이 양극(+) 긴 쪽이 음극(-)을 띄고 있습니다'
      },
      code: {
        type: 'E',
        name: 'LE'
      },
      data: {
        limit: 10,
        signal: 'output'
      },
      attr: {
        resist: 100.0
      }
    },
    {
      id: 5,
      group: 'micom',
      type: 'part',
      idname: 'Transistor',
      thumbnail: 'transistor.svg',
      name: {
        kor: '트랜지스터',
        en: 'Transistor'
      },
      info: {
        model: 'Tip41c PNP',
        img: 'transistor.png',
        description: '트랜지스터는 3개 이상의 단자를 가지고 있는 능동소자입니다. 능동소자란 입력과 출력을 가지고있어 신호를 증폭이나 변환시켜 전기에너지를 변환시키는 소자를 말합니다.'
      },
      code: {
        type: 'E',
        name: 'TR'
      },
      data: {
        limit: 5,
        signal: ''
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 6,
      group: 'micom',
      type: 'part',
      idname: 'TagSwitch',
      thumbnail: 'switch.svg',
      name: {
        kor: '택트 스위치',
        en: 'Tactile Switch'
      },
      info: {
        model: 'DM626',
        img: 'switch.png',
        description: '가장 흔한 스위치로 버튼이라고 불립니다. 회로 방식은 대체적으로 1회로 1접점의 누르면 On, 손을 떼면 Off 방식의 회로 구성 방식입니다.'
      },
      code: {
        type: 'E',
        name: 'TW'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 7,
      group: 'micom',
      type: 'sensor',
      idname: 'MSonicSensor',
      thumbnail: 'ultrasonic.svg',
      name: {
        kor: '초음파 센서',
        en: 'Ultrasonic Sensor'
      },
      info: {
        model: 'HC-SR04',
        img: 'ultrasonic.png',
        description: '초음파 센서는 초음파를 이용하여 거리를 측정하는 원리로 작동하는데, 두개의 스피커 중 왼쪽의 transmitter에서 초음파를 쏘고 물체에 맞아서 돌아오는 초음파를' +
          '오른쪽의 receiver에서 받아 걸린 시간을 계산하여 거리를 측정하는 원리입니다.' +
          '초음파 센서는 장애물의 거리를 계산하여 장애물을 피하는 용도로 자주 사용됩니다.'
      },
      code: {
        type: 'E',
        name: 'MS'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 200
      }
    },
    {
      id: 8,
      group: 'micom',
      type: 'sensor',
      idname: 'TSensor',
      thumbnail: 'tmp.svg',
      name: {
        kor: '온도 센서',
        en: 'Temperature Sensor'
      },
      info: {
        model: 'MAX6675',
        img: 'tmp.png',
        description: 'K-Type 써모커플과 MAX6675 써모커플 앰프와 함께 쓰이는 온도센서로' +
          '0도에서 800도까지 측정이 가능하므로 일반적인 온도 센서로 측정이 불가능한 고온이 측정 가능합니다.'
      },
      code: {
        type: 'E',
        name: 'TS'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 200
      }
    },
    {
      id: 9,
      group: 'micom',
      type: 'sensor',
      idname: 'ServoMotor',
      thumbnail: 'mini-servo-motor.svg',
      name: {
        kor: '미니 서보 모터',
        en: 'Servo Motor'
      },
      info: {
        model: 'SG90',
        img: 'servo_motor.png',
        description: '명령을 따라는 모터를 서보 모터라고 합니다. 서보 모터는 펄스를 주어 위치(각도)를 제어하는 모터이며 위치' +
          '피드백을 내부에서 구성하고 있으므로 고속으로 고정밀하게 각도를 조절할 수 있는 장점이 있습니다.'
      },
      code: {
        type: 'E',
        name: 'VM'
      },
      data: {
        limit: 5,
        signal: 'output'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 10,
      group: 'micom',
      type: 'sensor',
      idname: 'PIRSensor',
      thumbnail: 'pir.svg',
      name: {
        kor: '인체감지 센서',
        en: 'PIR Sensor'
      },
      info: {
        model: 'SR501',
        img: 'pir.png',
        description: '인체 감지 센서는 적외선을 통해서 사람의 움직임을 감지하는 원리로 작동됩니다. 사람의 인체에서는 적은 양의 적외선을 방출하는데 이렇게 방출된 적외선이 인체 감지 센서의' +
          '집광렌즈를 통해 적외선 센서 부분에 닿아 전압이 출력되는 원리입니다. 인체 감지 센서는 주로 아파트 현관등과 같이 사람이 지나가면 자동적으로 빛이 켜지는 곳에 활용됩니다.'
      },
      code: {
        type: 'E',
        name: 'PS'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 11,
      group: 'micom',
      type: 'sensor',
      idname: 'PhotoResistor',
      thumbnail: 'photo-resistor.svg',
      name: {
        kor: '조도 센서',
        en: 'Photo Resistor'
      },
      info: {
        model: 'CDS 타입',
        img: 'photo-resistor.png',
        description: '조도는 빛의 밝고 어두운정도를 나타낸다고 말할 수 있습니다.' +
          '조도센서는 들어오는 빛의 양에따라서 값이 변하게되는데 빛의 양이 많아질수록 전도율이 높아져 저항값이 낮아지게 되고, 빛의양이 적을수록 저항값이 높아지게되는 원리로 전압을 조절하게 됩니다.'
      },
      code: {
        type: 'E',
        name: 'PR'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 200
      }
    },
    {
      id: 12,
      group: 'micom',
      type: 'sensor',
      idname: 'Relay',
      thumbnail: 'relay.svg',
      name: {
        kor: '릴레이 모듈',
        en: 'Relay'
      },
      info: {
        model: '1채널 5V 릴레이 모듈',
        img: 'relay.png',
        description: '릴레이는 쉽게 말해 ON, OFF가 있는 일종의 스위치입니다. 우리가 일반적으로 접하는 스위치는 수동으로 ON, OFF 해주지만, ' +
          '릴레이는 자동으로 ON,OFF 할 수 있게끔 해주는 전자부품 입니다. 릴레이는 별도로 분리되어 흐르는 전기를 스위칭할 수 있는 신호 또는 펄스를 만들어 주며, 흔히 낮은 전압/전류를 이용하여 더 높은 전압/전류를 제어하는데에 많이 사용합니다.'
      },
      code: {
        type: 'E',
        name: 'RL'
      },
      data: {
        limit: 5,
        signal: 'output'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 13,
      group: 'micom',
      type: 'part',
      idname: 'DipSwitch',
      thumbnail: 'dip-switch.svg',
      name: {
        kor: '딥 스위치',
        en: 'Dip Switch'
      },
      info: {
        model: '1핀',
        img: 'dip_switch.png',
        description: 'DIP 스위치는 여러 개의 ON/OFF 스위치가 정렬되어 있는 스위치 박스를 말합니다.'
      },
      code: {
        type: 'E',
        name: 'DW'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 0,
        value: 0
      }
    },
    {
      id: 14,
      group: 'micom',
      type: 'sensor',
      idname: 'LCD',
      thumbnail: 'lcd.svg',
      name: {
        kor: 'LCD',
        en: 'LCD'
      },
      info: {
        model: '16*2 LCD 5V - I2C',
        img: 'lcd.png',
        description: 'LCD는 Liquid Crystal Display의 약자로 액정표시장치를 말합니다. 여기에서 액정 (Liquid Crystal)이란 액체처럼 유체의 성질을 가지면서 ' +
          '고체처럼 광학적 성질을 가지는 물질입니다. 또한 액정은 고체표면에 액정이 특정 방향으로 정렬할 수도 있어, 전기적 신호를 가해 원하는 방향으로 배열하여 빛을 투과시키거나 차단시킬 수 있습니다.'
      },
      code: {
        type: 'E',
        name: 'LC'
      },
      data: {
        limit: 5,
        signal: 'output'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 15,
      group: 'micom',
      type: 'motor',
      idname: 'DCMotor',
      thumbnail: 'dc-motor-front.svg',
      name: {
        kor: 'DC 모터',
        en: 'DC Motor'
      },
      info: {
        model: '-',
        img: 'dc-motor.png',
        description: '가장 기본적인 DC모터의 원형으로서 일반적으로 가장 많이 사용하는 모터이다. 적당한 전력만 공급해 주면 회전은 하므로 팬 또는 RC자동차 구동 등 여러 용도로 많이 사용됩니다. ' +
          '단지 한방향 일정 속도로 회전만을 원한다면 전원공급만 해주면 되지만 회전방향을 바꾼다든지 회전속도를 제어하고 싶다면 DC모터 드라이버회로를 사용해서 +/- 공급 방향과 공급전압을 조절해 주어야 합니다.'
      },
      code: {
        type: 'E',
        name: 'DM'
      },
      data: {
        limit: 5,
        signal: 'output'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 16,
      group: 'micom',
      type: 'motor',
      idname: 'DCMotorSide',
      thumbnail: 'dc-motor-side.svg',
      name: {
        kor: 'DC 모터 옆면',
        en: 'DC Motor Side'
      },
      info: {
        model: '-',
        img: 'dc-motor.png',
        description: '가장 기본적인 DC모터의 원형으로서 일반적으로 가장 많이 사용하는 모터이다. 적당한 전력만 공급해 주면 회전은 하므로 팬 또는 RC자동차 구동 등 여러 용도로 많이 사용됩니다. ' +
          '단지 한방향 일정 속도로 회전만을 원한다면 전원공급만 해주면 되지만 회전방향을 바꾼다든지 회전속도를 제어하고 싶다면 DC모터 드라이버회로를 사용해서 +/- 공급 방향과 공급전압을 조절해 주어야 합니다.'
      },
      code: {
        type: 'E',
        name: 'DM'
      },
      data: {
        limit: 5,
        signal: 'output'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 17,
      group: 'micom',
      type: 'sensor',
      idname: 'DHSensor',
      thumbnail: 'dht11.svg',
      name: {
        kor: '온습도 센서',
        en: 'DHT11 Sensor'
      },
      info: {
        model: 'DHT11',
        img: 'dht11.png',
        description: '온도와 습도를 같이 측정하는 아두이노 부품을 온습도 센서라고 합니다.'
      },
      code: {
        type: 'E',
        name: 'DS'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 18,
      group: 'micom',
      type: 'sensor',
      idname: 'Joystick',
      thumbnail: 'joystick.svg',
      name: {
        kor: '조이스틱',
        en: 'Joy Stick'
      },
      info: {
        model: '-',
        img: 'joystick.png',
        description: '조이스틱은 스틱이라 불리는 긴 막대형의 레버를 잡고 상하좌우로 밀거나 당겨서 조작하는 방식의 컨트롤러/입력장치입니다.' +
          '항공기의 보조날개와 승강타를 조종하기 위한 기계 장치로 개발되었습니다.'
      },
      code: {
        type: 'E',
        name: 'JT'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 19,
      group: 'micom',
      type: 'sensor',
      idname: 'ForceSensor',
      thumbnail: 'pressure-sensor.svg',
      name: {
        kor: '압력 센서',
        en: 'Force Sensor Resistor'
      },
      info: {
        model: 'FSR402',
        img: 'force-sensor.png',
        description: 'FSR(Force Sensing Resistor)이라는 이름으로 알려져 있는 저항방식 센서는 압력이 가해지면 저항이 달라지는 특성을 이용한 센서 입니다.' +
          'FSR을 이용해 가해진 힘의 크기를 정확하게 측정하는 등에는 적합하지 않지만, 힘의 세기나 접촉의 유무 등에 사용하기에 적합합니다'
      },
      code: {
        type: 'E',
        name: 'FS'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 20,
      group: 'micom',
      type: 'sensor',
      idname: 'AccSensor',
      thumbnail: 'acceleration-sensor.svg',
      name: {
        kor: '가속도 센서',
        en: 'Acceleration Sensor'
      },
      info: {
        model: 'MPU-6050',
        img: 'accelerator.png',
        description: '가속도센서란 지구의 중력가속도를 기준으로 사물이 얼마만큼의 힘을 받고 있는지를 측정하는 센서입니다.' +
          '중력 가속도를 X, Y, Z 축으로 벡터 3개로 나누어 크기를 측정하여 나타냅니다. 가속도센서의 값들은 정지된 상태에서도 특정한 값을 갖기 때문에 기울어진 정도를 파악하거나 진동을 파악하는데 많이 사용됩니다.'
      },
      code: {
        type: 'E',
        name: 'AS'
      },
      data: {
        limit: 1,
        signal: 'input'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 21,
      group: 'micom',
      type: 'sensor',
      idname: 'UniMotorDriver',
      thumbnail: 'unipolar-motor-driver.svg',
      name: {
        kor: '유니폴라 모터드라이버',
        en: 'Unipolar Motor Driver'
      },
      info: {
        model: '-',
        img: 'unipolar_driver.png',
        description: '유니폴라를 아두이노에서 구동 및 제어할 수 있도록 도와주는 드라이버입니다.'
      },
      code: {
        type: 'E',
        name: 'SD'
      },
      data: {
        limit: 1,
        signal: ''
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 22,
      group: 'micom',
      type: 'motor',
      idname: 'StepMotorDriver',
      thumbnail: 'unipolar_motor.svg',
      name: {
        kor: '유니폴라 스텝모터',
        en: 'Unipolar Step-Motor'
      },
      info: {
        model: 'uniploar(유니폴라)',
        img: 'unipolar_driver.png',
        description: '스테핑모터는 step 상태에서 pulse에 순서를 부여하여 주어진 펄수 수에 비례한 각도 만큼 회전하는 모터를 말합니다.' +
          '구동방식에 따라 유니폴라(6핀)와 바이폴라(4핀)로 나뉘며 유니폴라의 경우 모터의 코일에 흐르는 전류가 항상 한쪽 방향으로만 흐르는 것이 특징입니다.' +
          '유니폴라는 고속회전에 용이하고 구동 회로가 간단한 장점이 있습니다.'
      },
      code: {
        type: 'E',
        name: 'SM'
      },
      data: {
        limit: 1,
        signal: 'output'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 23,
      group: 'micom',
      type: 'sensor',
      idname: 'InfraredSensor',
      thumbnail: 'infrared.svg',
      name: {
        kor: '적외선 센서',
        en: 'Infrared Sensor'
      },
      info: {
        model: 'PP-A071',
        img: 'infrared.png',
        description: '적외선 센서는 적외선을 이용해 온도와 압력, 방사선의 세기 등의 물리량이나 화학량을 감지하여 신호처리가 가능한 전기량으로 변환하는 장치입니다.'
      },
      code: {
        type: 'E',
        name: 'IS'
      },
      data: {
        limit: 5,
        signal: 'input'
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 24,
      group: 'micom',
      type: 'sensor',
      idname: 'DCMotorDriver',
      thumbnail: 'motor-driver.svg',
      name: {
        kor: '모터드라이버',
        en: 'DC Motor Driver'
      },
      info: {
        model: '-',
        img: '-',
        description: '모터 드라이버는 작은 전류와 전압을 제어하는 프로세서와 큰 전류로 작동하는 모터 사이에 중재 역할을 하는 장치입니다.' +
          '따라서 프로세서의 작은 전압을 제어하여 모터의 속도를 제어하고, 모터의 방향을 바꿀 수 있는 회로 장치를 통상 모터 드라이버라 부릅니다.'
      },
      code: {
        type: 'E',
        name: 'MD'
      },
      data: {
        limit: 1,
        signal: ''
      },
      attr: {
        resist: 0
      }
    },
    {
      id: 25,
      group: 'micom',
      type: 'tool',
      idname: 'Powersupply',
      thumbnail: 'new-powersupply.svg',
      name: {
        kor: '전원공급기',
        en: 'Powersupply'
      },
      info: {
        model: '',
        img: '',
        description: ''
      },
      code: {
        type: 'E',
        name: 'PW'
      },
      data: {
        limit: 3,
        signal: ''
      },
      attr: {
        v1: 0,
        v2: 0,
        a1: 0,
        a2: 0,
        resist: 0
      }
    },
    {
      id: 26,
      group: 'micom',
      type: 'tool',
      idname: 'Multimeter',
      thumbnail: 'new-multimeter.svg',
      name: {
        kor: '멀티미터',
        en: 'Multimeter'
      },
      info: {
        model: '',
        img: '',
        description: ''
      },
      code: {
        type: 'E',
        name: 'MT'
      },
      data: {
        limit: 3,
        signal: 'output'
      },
      attr: {
        resist: 0,
        unit: 'AE', // current => AE, voltage => VE
        amper: 0,
        volt: 0
      }
    },
    {
      id: 27,
      group: 'micom',
      type: 'tool',
      idname: 'Functiongen',
      thumbnail: 'new-functiongen.svg',
      name: {
        kor: '함수발생기',
        en: 'Function Generator'
      },
      info: {
        model: '',
        img: '',
        description: ''
      },
      code: {
        type: 'E',
        name: 'FG'
      },
      data: {
        limit: 2,
        signal: ''
      },
      attr: {
        resist: 0,
        ch1: {}, // ch1: { func: 0, hz: 0, amp: 0, offset: 0 }
        ch2: {} // ch2: { func: 0, hz: 0, amp: 0, offset: 0 }
      }
    },
    {
      id: 28,
      group: 'micom',
      type: 'tool',
      idname: 'Oscilloscope',
      thumbnail: 'new-oscilloscope.svg',
      name: {
        kor: '오실로스코프',
        en: 'Oscilloscope'
      },
      info: {
        model: '',
        img: '',
        description: ''
      },
      code: {
        type: 'E',
        name: 'OS'
      },
      data: {
        limit: 2,
        signal: 'output'
      },
      attr: {
        resist: 0,
        func: 0,
        hz: 0,
        amp: 0,
        offset: 0
      }
    },
    {
      id: 29,
      group: 'micom',
      type: 'part',
      idname: 'Probe',
      thumbnail: 'probe.svg',
      name: {
        kor: '프로브',
        en: 'Probe'
      },
      info: {
        model: '',
        img: '',
        description: ''
      },
      code: {
        type: 'E',
        name: 'PB'
      },
      data: {
        limit: 5,
        signal: ''
      },
      attr: {
        resist: 0
        // attenuation: 10 // 감쇄
      }
    },
    {
      id: 30,
      group: 'micom',
      type: 'part',
      idname: 'Diode',
      thumbnail: 'diode.svg',
      name: {
        kor: '다이오드',
        en: 'Diode'
      },
      info: {
        model: '다이오드',
        img: 'diode.svg',
        description: '다이오드는 전류의 방향을 한쪽으로만 흐르게 하는 소자입니다. 정방향 전류는 일정 전류 이상(스펙에 따라 다름) 에서 거의 전부를 통과 시킵니다. 역방향 전류에 대해서는 항복 전압 이상 인가시 파괴됩니다.'
      },
      code: {
        type: 'E',
        name: 'DI'
      },
      data: {
        limit: 10,
        signal: ''
      },
      attr: {
        resist: 330
      }
    },
    {
      id: 31,
      group: 'micom',
      type: 'part',
      idname: 'Inductor',
      thumbnail: 'inductor.svg',
      name: {
        kor: '인덕터',
        en: 'Inductor'
      },
      info: {
        model: '인덕터',
        img: 'inductor.svg',
        description: ''
      },
      code: {
        type: 'E',
        name: 'IT'
      },
      data: {
        limit: 10,
        signal: ''
      },
      attr: {
        henry: 1,
        resist: 330,
      }
    },
    {
      id: 32,
      group: 'micom',
      type: 'part',
      idname: 'Capacitor',
      thumbnail: 'capacitor.svg',
      name: {
        kor: '콘덴서',
        en: 'Capacitor'
      },
      info: {
        model: '콘덴서',
        img: 'capacitor.svg',
        description: ''
      },
      code: {
        type: 'E',
        name: 'CP'
      },
      data: {
        limit: 10,
        signal: ''
      },
      attr: {
        farad: 1,
        resist: 330,
      }
    },
    {
      id: 33,
      group: 'micom',
      type: 'part',
      idname: 'Potentiometer',
      thumbnail: 'potentiometer.svg',
      name: {
        kor: '가변저항',
        en: 'Potentiometer'
      },
      info: {
        model: '가변저항',
        img: 'potentiometer.svg',
        description: ''
      },
      code: {
        type: 'E',
        name: 'PM'
      },
      data: {
        limit: 10,
        signal: 'input'
      },
      attr: {
        resist: 330
      }
    }
  ],
  findSingalType: function (id) {
    const idname = id.substring(0, id.indexOf('_'))
    const obj = this.find('idname', idname)
    return obj.data.signal
  },
  setNumberOfElcts: function (list = this.items) {
    const obj = {}
    list.forEach(item => {
      obj[item.idname] = {}
      obj[item.idname].limit = item.data.limit
      obj[item.idname].totaluse = 0

      const seats = []
      for (let i = 0; i < item.data.limit; i++) {
        const number = i < 10 ? '0' + String(i) : String(i)
        seats.push({
          name: item.idname + "_" + number,
          taken: false
        })
      }
      obj[item.idname].seats = seats

      // console.log('data/cpts/component/setNumberOfElcts', item.idname, seats)
    })
    // console.log('data/cpts/component/setNumberOfElcts', obj)
    store.commit('elct/setNumberOfElcts', obj)
  },
  find: function (attr, name) {
    return this.items.find(item => item[attr] === name)
  },
  findByCodeName: function (name) {
    return this.items.find(item => item.code.name === name)
  },
  findByIdName: function (name) {
    return this.items.find(item => item.idname === name)
  },
  convertIdToCodeName: function (elctid) {
    const idname = elctid.substring(0, elctid.indexOf('_'))
    return this.find('idname', idname).code.name
  },
  convertIdToCode: function (elctid) {
    const idname = elctid.substring(0, elctid.indexOf('_'))
    let number = elctid.substring(elctid.indexOf('_') + 1)
    number = number.length < 2 ? '0' + number : number
    const code = this.find('idname', idname).code.name
    return code + '-' + number
  },
  convertCodeToId: function (codename) {
    let name = codename.substr(0, 2)
    if (name === 'VE' || name === 'AE') name = 'MT'
    const number = (name === 'OS') ? Number(codename.charAt(codename.length - 1)) : Number(codename.substr(3, 2))
    const idname = this.findByCodeName(name).idname
    console.log(name, number, idname)
    return idname + '_' + (number < 9 ? "0" : "") + number.toString()
  }
}
